import { useT } from "../i18n";
import { Seitenkopf } from "../bausteine/Handyformen";
import { NachschlagenTelefon } from "./NachschlagenTelefon";

/* ══════════════════════════════════════════════════════════════════
   „Preis" am Telefon — eine Seite (Signal, Paket 5, 07.10.2026).

   Bis hierher öffnete das Fach „Preis" das Nachschlagen als Blatt über der
   Maske, auf der man stand. Nach app-design-muster (`navigation.md` § 2: ein
   Fach der Leiste ist ein Ort, keine Handlung) und Lucas Entscheidung F5 ist
   es jetzt eine Seite mit eigenem Stand. **Der Inhalt ist derselbe** —
   `NachschlagenTelefon`, eins zu eins, samt Vorbelegung über `?typ=…`
   (`router.tsx`). Das Nachschlagen über der Maske gibt es weiter: als Lupe mit
   Euro im Kopf, für die Frage zwischendurch.
   ══════════════════════════════════════════════════════════════════ */
export function PreisTelefon() {
  const t = useT();
  return (
    <div className="handy preis-seite">
      <Seitenkopf titel={t("handyLeiste.preis")} unter={t("nachschlagen.unter")} />
      <NachschlagenTelefon />
    </div>
  );
}
